function escapeCsv(value) {
  const stringValue = value === null || value === undefined ? '' : String(value);

  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
}

function resultToCsv(result, signature = null) {
  const metadataRows = [
    ['randFlow Version', result.version],
    ['Generated At', result.timestamp],
    ['Technique', result.algorithm],
    ['Seed', result.seed],
    ['N', result.parameters.n],
    ['Arms', result.parameters.arms],
    ['Arm Labels', result.parameters.armLabels.join('; ')],
    ['Validation', result.metrics.validation],
    ['Imbalance', result.metrics.imbalance],
    ['Imbalance Percent', `${result.metrics.imbalancePercent}%`],
    ['Experiment Signature', signature || ''],
    []
  ];

  const header = ['Patient ID', 'Sequence Order', 'Arm', 'Arm Index', 'Block', 'Cluster', 'Stratum'];
  const body = result.sequence.map((patient) => [
    patient.patientId,
    patient.sequenceOrder,
    patient.arm,
    patient.armIndex + 1,
    patient.blockNumber || '',
    patient.cluster || '',
    patient.stratum || ''
  ]);

  return [...metadataRows, header, ...body]
    .map((row) => row.map(escapeCsv).join(','))
    .join('\n');
}

function resultToOperationalCsv(result, signature = null) {
  const metadataRows = [
    ['randFlow Version', result.version],
    ['Generated At', result.timestamp],
    ['Technique', result.algorithm],
    ['Seed', result.seed],
    ['N', result.parameters.n],
    ['Arms', result.parameters.arms],
    ['Validation', result.metrics.validation],
    ['Experiment Signature', signature || result.experimentSignature || ''],
    ['Operational Mode', result.operationalMode ? 'active' : 'not active'],
    ['Revealed Count', result.operationalMode ? result.operationalMode.revealedCount : ''],
    ['Concealed Count', result.operationalMode ? result.operationalMode.concealedCount : ''],
    []
  ];

  const header = ['Patient ID', 'Sequence Order', 'Reveal Status', 'Arm', 'Arm Index', 'Block', 'Cluster', 'Stratum'];
  const body = result.sequence.map((patient) => [
    patient.patientId,
    patient.sequenceOrder,
    patient.revealStatus || 'revealed',
    patient.arm || '',
    patient.armIndex === null || patient.armIndex === undefined ? '' : patient.armIndex + 1,
    patient.blockNumber || '',
    patient.cluster || '',
    patient.stratum || ''
  ]);

  return [...metadataRows, header, ...body]
    .map((row) => row.map(escapeCsv).join(','))
    .join('\n');
}

module.exports = {
  resultToCsv,
  resultToOperationalCsv
};
